import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {
  public selectedLanguageFlag: string = 'es';
  selectedLanguageText: 'English'

  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  constructor(
    private authService: AuthService,
    public dataService: DataService,
    public translate: TranslateService,

  ) { }

  ngOnInit(): void {
    this.dataService.getLang().subscribe(res => {
      // 
      this.selectedLanguageFlag = res.toString();
    });
  }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
  }

  logout() {
    //  this.firebase.signOut();
    this.authService.logout();
  }

  changeLang(lang: string) {
    localStorage.setItem('language', lang)
    this.selectedLanguageFlag = lang
    this.dataService.changeLang(lang).subscribe(res => {
      if (res == 'updated') {
        this.translate.use(lang);
      }

    });

  }


}
